import i18n from 'modules/core/lib/i18n'

// Translation keys for the collection
export const getEmptyStates = () => ({
  'no-data': {
    title: i18n.t('banking.accounts.empty_state.title'),
    description: i18n.t('banking.accounts.empty_state.description'),
  },
})
